import Vue from 'vue'
import VueRouter from 'vue-router'
import { Forbidden, Login, LoginChrismas, NotFound, Welcome, Search, GeneralPrinciple, LoginAsStudent } from './components'
import { Register, ForgotPassword, RegisterAnomynous } from './components/auth'
import { Profile, AccountVerify } from './components/profile'
import { DailyChallenge, DailyBonus } from './components/reward'
import { Inbox } from './components/inbox'
import { LeaderBoard } from './components/leaderboard'
import { ExchangeGift, ExchangeHistory, BuySticker, ExchangeCollection } from './components/exchange_gift'
import { ParentFeedback, ParentReport, ParentAccount, ParentUpgradeAccount, ParentCertificate, ParentIclassReport } from './components/parent'
import { UnitList, LessonDetail, LessonVocabulary, LessonLecture, LessonPractice, ExtensionDetail, PrepList } from './components/unit'
import { Tutoring } from './components/toturing'
import { LiveClass } from './components/live_class'
import { PlacementTest } from './components/placement_test'
import { FinalTest } from './components/final_test'
import { Faq } from './components/faq'
import { Ebook, EbookHome } from './components/ebook'
import { PaymentDetail, UpgradeAccount, UpgradeFeature } from './components/payment'


import { store } from './store'
import Achievement from "./components/achievement/Achievement";
import Webview from './components/ai_tutor/Webview.vue'

const router = new VueRouter({
    mode: 'history',
    routes: [
        { path: '/', name: 'home', component: Welcome, meta: { requiresAuth: true, title: 'Trang chủ' } },
        { path: '/general-principle', alias: ['/privacy-policy', '/delivery-policy', '/refund-policy'], name: 'general_principle', component: GeneralPrinciple, meta: { layout: 'empty-layout', title: 'Terms & Policies' } },


        { path: '/404', name: 'not_found', component: NotFound, meta: { title: 'Trang không tồn tại' } },
        { path: '/403', name: 'forbidden', component: Forbidden, meta: { title: 'Lỗi dịch vụ' } },

        { path: '/apps', name: 'apps', meta: { layout: 'landing-page-layout' } },

        { path: '/login', name: 'login', component: Login, meta: { layout: 'auth-layout', title: 'Trang đăng nhập tài khoản' } },
        { path: '/register', name: 'register', component: Register, meta: { layout: 'auth-layout', title: 'Trang đăng ký tài khoản' } },
        // { path: '/register-anomynous', name: 'register_anomynous', component: RegisterAnomynous, meta: { layout: 'auth-layout', title: 'Trải nghiệm thử'  } },
        { path: '/forgot-password', name: 'forgot_password', component: ForgotPassword, meta: { layout: 'auth-layout', title: 'Quên mật khẩu' } },

        { path: '/search', name: 'search', component: Search, meta: { title: 'Trang tìm kiếm' } },

        { path: '/profile', name: 'profile', component: Profile, meta: { title: 'Trang thông tin tài khoản' } },
        { path: '/account-verify-:tab', name: 'account_verify', component: AccountVerify, meta: { title: 'Xác thực thông tin tài khoản' } },
        { path: '/daily-challenge', name: 'daily_challenge', component: DailyChallenge, meta: { title: 'Thử thách hàng ngày' } },
        { path: '/daily-bonus', name: 'daily_bonus', component: DailyBonus, meta: { title: 'Thưởng đăng nhập hàng ngày' } },
        { path: '/inbox', name: 'inbox', component: Inbox, meta: { title: 'Trang thông báo' } },
        { path: '/exchange-gift', name: 'exchange_gift', component: ExchangeGift, meta: { title: 'Trang đổi quà tặng' } },
        { path: '/exchange-history', name: 'exchange_history', component: ExchangeHistory, meta: { title: 'Trang lịch sử đổi thưởng' } },
        { path: '/exchange-collection', name: 'exchange_collection', component: ExchangeCollection, meta: { title: 'Trang bộ sưu tập' } },
        { path: '/buy-sticker', name: 'buy_sticker', component: BuySticker, meta: { title: 'Trang mua sticker' } },
        { path: '/leaderboard', name: 'leaderboard', component: LeaderBoard, meta: { title: 'Bảng xếp hạng' } },
        { path: '/unit/:subject_id/:unit_id/:page', name: 'unit', component: UnitList },
        { path: '/prep/:subject_id/:unit_id/:page', name: 'prep', component: PrepList },
        { path: '/mission', name: 'achievement', component: Achievement },
        { path: '/lesson/:subject_id-:unit_id-:lesson_id', name: 'lesson_detail', component: LessonDetail },
        { path: '/extension/:subject_id-:unit_id-:lesson_id', name: 'extension_detail', component: ExtensionDetail },
        { path: '/lesson/vocabulary/:item_id', name: 'lesson_vocabulary', component: LessonVocabulary },
        { path: '/lesson/lecture/:item_id', name: 'lesson_lecture', component: LessonLecture },
        { path: '/lesson/practice/:item_id', name: 'lesson_practice', component: LessonPractice },
        { path: '/parent/report', name: 'parent_report', component: ParentReport, meta: { title: 'Dành cho phụ huynh - Báo cáo học tập' } },
        { path: '/parent/feedback', name: 'parent_feedback', component: ParentFeedback, meta: { title: 'Dành cho phụ huynh - Phản hồi' } },
        { path: '/parent/account', name: 'parent_account', component: ParentAccount, meta: { title: 'Dành cho phụ huynh - Thông tin tài khoản' } },
        { path: '/parent/certificate', name: 'parent_certificate', component: ParentCertificate, meta: { title: 'Dành cho phụ huynh - Chứng chỉ học tập' } },
        { path: '/parent/upgrade-account', name: 'parent_upgrade_account', component: ParentUpgradeAccount, meta: { title: 'Dành cho phụ huynh - Nâng cấp tài khoản' } },
        { path: '/parent/iclass-report', name: 'parent_iclass_report', component: ParentIclassReport, meta: { title: 'Dành cho phụ huynh - IClass report' } },
        { path: '/upgrade-account', name: 'upgrade_account', component: UpgradeAccount, meta: { title: 'Trang nâng cấp tài khoản' } },
        { path: '/upgrade-feature', name: 'upgrade_feature', component: UpgradeFeature, meta: { title: 'Trang nâng cấp tính năng' } },
        { path: '/tutoring', name: 'tutoring', component: Tutoring, meta: { title: 'Trang học bổ trợ trực tuyến' } },
        { path: '/live-class', name: 'live_class', component: LiveClass, meta: { title: 'Trang học trực tuyến' } },
        { path: '/payment/detail', name: 'payment_detail', component: PaymentDetail, meta: { layout: 'payment-layout', title: 'Trang thanh toán' } },


        { path: '/placement-test/:item_id', name: 'placement_test', component: PlacementTest },

        { path: '/final-test/:item_id/:subject_id', name: 'final_test', component: FinalTest },

        { path: '/faqs', name: 'faqs', component: Faq, meta: { layout: 'blank-layout', title: 'Trang hỏi & đáp' } },

        { path: '/ebook/:unit_id', name: 'ebook', component: Ebook, meta: { layout: 'empty-layout' } },
        { path: '/ebook-home', name: 'ebook_home', component: EbookHome, meta: { layout: 'empty-layout', title: 'Trang chủ Ebook' } },

        { path: '*', component: { default: NotFound, helper: NotFound }, meta: { layout: 'error-layout' } },

        { path: '/user/login-as-student/:username', name: 'login_as_student', component: LoginAsStudent },
        { path: '/ai-tutor', name: 'ai_tutor', component: Webview, meta: { layout: 'empty-layout' } }
    ],
    scrollBehavior(to, from, savedPosition) {
        return {
            x: 0,
            y: 0,
        };
    }
});

router.beforeEach((to, from, next) => {
    if (!['login', 'forgot_password', 'register', 'general_principle', 'ai_tutor'].includes(to.name)  && !store.getters.isLoggedIn) {
        // console.log(to, store.getters.isLoggedIn);
        next({ name: 'login' });
    } else {
        next();
    }

    // // If this isn't an initial page load.
    // if (to.matched.some(record => record.meta.requiresAuth)) {
    //     if (store.getters.isLoggedIn) {
    //         //store.dispatch("SET_USER_INFO");

    //         store.commit('setLoading', true);

    //         next();

    //         return
    //     }

    //     console.log('Auth from route')

    //     // next('/register-anomynous')
    //     next('/login')
    // }

    // //store.commit("setLoading", true);

    // if (to.name) {
    //     // Start the route progress bar.
    // }

    // next()
});


router.afterEach((to, from) => {
    const DEFAULT_TITLE = 'iSMART Pro';
    store.commit('setLoading', false);
    Vue.nextTick(() => {
        document.title = to.meta.title ? DEFAULT_TITLE + ' - ' + to.meta.title : DEFAULT_TITLE;
    });
});

export default router;